import checkTypes from "check-types";
import FileData from "components/organisms/editor/core/model/lib/file_data/base";

const { assert } = checkTypes;

/**
 * @import { RawHollowBinaryFileData } from '../types'
 */

class HollowBinaryFileData extends FileData {
    /**
     * @param {number} byteLength
     * @see FileData
     */
    constructor(byteLength) {
        super();
        assert.integer(byteLength, "HollowBinaryFileData: bad byteLength");
        assert.greaterOrEqual(byteLength, 0, "HollowBinaryFileData: low byteLength");
        this.byteLength = byteLength;
    }

    /**
     * @param {RawHollowBinaryFileData} raw
     * @returns {HollowBinaryFileData}
     */
    static fromRaw(raw) {
        return new HollowBinaryFileData(raw.byteLength);
    }

    /**
     * @inheritdoc
     * @returns {RawHollowBinaryFileData}
     */
    toRaw() {
        return { byteLength: this.byteLength };
    }

    /** @inheritdoc */
    getByteLength() {
        return this.byteLength;
    }

    /** @inheritdoc */
    isEditable() {
        return false;
    }

    /** @inheritdoc */
    async toHollow() {
        return this;
    }
}

export default HollowBinaryFileData;
